/**
 * What each RGS command IS — the one place that knows.
 *
 * Three games share one transport (rgsPlay → provider spin()), and every
 * state leak between them so far came from the same defect: a consumer met a
 * command it did not recognize and treated it as a base spin by default. The
 * gamble reached base storage, base isSpinning, and the feature spin flags
 * that way, one scattered string-check at a time.
 *
 * So the default is flipped here: an unknown command is NOTHING. Only what
 * this map names may touch spin state or storage, and a new command does not
 * exist until it is classified below.
 *
 *   base      the base game's own spin — moves base isSpinning/spinComplete,
 *             is saved as base_game_round. `spin` covers free rounds and the
 *             buys too: a buy is sent as command "spin" with a
 *             purchased_feature, and its board is the base screen.
 *   feature   a spin played on a feature's own board with its own round —
 *             Pot Collection's respin, Mad Labs' freespin. Never moves base
 *             spin state, never saved as the base round.
 *   decision  no reels at all — an answer to a question the server asked
 *             (the free-spins gamble). Touches NEITHER spin state: the
 *             trigger win is still celebrating on the board behind it.
 */
export const COMMAND_KIND = {
  BASE: "base",
  FEATURE: "feature",
  DECISION: "decision",
};

const KIND_BY_COMMAND = {
  spin: COMMAND_KIND.BASE,
  respin: COMMAND_KIND.FEATURE,
  freespin: COMMAND_KIND.FEATURE,
  gamble_freespins: COMMAND_KIND.DECISION,
  collect_freespins: COMMAND_KIND.DECISION,
};

/** The kind of a response's `command`, or null when the map does not know it. */
export const kindOfCommand = (command) => KIND_BY_COMMAND[command] ?? null;

/**
 * The kind of an rgsPlay OPTIONS object — for pending/rejected, where the
 * response has not named the command yet and intent is all there is.
 * Returns null for a plain base spin: the request itself does not say, and
 * the caller falls back on featureSpinActive exactly as before.
 */
export const kindOfSpinArg = (arg) => {
  if (arg?.gambleAction) return COMMAND_KIND.DECISION;
  if (arg?.freeSpin) return COMMAND_KIND.FEATURE;
  if (arg?.respin) return COMMAND_KIND.FEATURE; // Cleopatra's Hold & Win
  return null;
};
